exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Footer{padding:35px 0}.Footer-social{margin:15px 0}.Footer-copyright{margin-top:15px}@media(min-width:768px){.Footer-social{margin:0}.Footer-copyright,.Footer-links{margin-top:15px}}@media(min-width:992px){.Footer{padding:60px 0 40px}}", ""]);

// exports
exports.locals = {
	"Footer": "Footer",
	"Footer-social": "Footer-social",
	"Footer-copyright": "Footer-copyright",
	"Footer-links": "Footer-links"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Footer/Footer.scss
 ** module id = 155
 ** module chunks = 0
 **/